import RecordAudioPage from './record-audio.page'

export default RecordAudioPage
